import { Component, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { AdministratorService } from '../../../../services/administrator.service';
import { SharedModule } from '../../../../shared/shared.module';
import { CustomerService } from '../../../../services/customer.service';
import { InventoryService } from '../../../../services/inventory.service';
import { MenuItem } from 'primeng/api';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { GLDefaultsLookupComponent } from '../../../Lookup/gl-defaults-lookup/gl-defaults-lookup.component';
import { DepartmentDefaultLookupComponent } from '../../../Lookup/department-default-lookup/department-default-lookup.component';
import { AbstractControl, ValidatorFn } from '@angular/forms';
import { gstinValidator } from '../../../../validators/gstin.validator';
import { gstinStateMatchValidator } from '../../../../validators/gstin-state.validator';

@Component({
  selector: 'app-new-warehouse',
  standalone: true,
  imports: [SharedModule, CommonModule],
  providers: [MessageService],
  templateUrl: './new-warehouse.component.html',
  styleUrl: './new-warehouse.component.scss'
})
export class NewWarehouseComponent {


  constructor(private messageService: MessageService, private router: Router, private routers: ActivatedRoute, public ref: DynamicDialogRef,
    private warehouseService: AdministratorService, private customerService: CustomerService, public inventoryService: InventoryService, public dialogService: DialogService,) { }

  submitted: boolean = false;
  isEditMode: boolean = false;
  warehouseId: number | undefined;
  Addressid: any
  stateList: any[] = [];
  filterStates: any[] = [];
  unitLabel: string = '';
  companyId: string | null = null;
  isGstinValidationEnabled = false;


  createWarehouseForm = new FormGroup({
    warehouseCode: new FormControl('', Validators.required),
    warehouseName: new FormControl('', Validators.required),
    unitSerial: new FormControl('', Validators.required),
    startingNumber: new FormControl('', Validators.required),
    isActive: new FormControl(true, Validators.requiredTrue),
    contactName: new FormControl('', Validators.required),
    email: new FormControl('', [Validators.email, Validators.required]),
    mobile: new FormControl('', [Validators.required, Validators.pattern(/^\d{10}$/)]),
    panNo: new FormControl(),
    phone: new FormControl('', [Validators.pattern(/^\d{10}$/)]),
    createdBy: new FormControl(''),
    upatedBy: new FormControl(''),
    companyId: new FormControl(),
    // addressId:new FormControl(''),
    //gstin: new FormControl('', [Validators.required, gstinValidator()]),
    gstin: new FormControl(''),
    address: new FormGroup({
      addressLine1: new FormControl('', Validators.required),
      addressLine2: new FormControl(''),
      city: new FormControl('', Validators.required),
      state: new FormControl('', Validators.required),
      zip: new FormControl('', [Validators.required, Validators.pattern(/^\d{6}$/)]),
      country: new FormControl('India', Validators.required),
      stateCode: new FormControl(''),
      CreatedBy: new FormControl(''),
      UpdatedBy: new FormControl(''),
    })
  });


  ngOnInit(): void {
    this.getit();
    this.getStateList();
    this.inventoryService.getUnitByAppKey('unitNameLabel').subscribe((res: any) => {
      this.unitLabel = res?.data || 'Unit';
      this.setPageTitle();
    });
    this.getEinvoiceSetting();
  }




  setPageTitle() {
    document.title = `Create ${this.unitLabel}`;
  }


  getit() {
    this.routers.queryParams.subscribe(params => {
      this.warehouseId = params['warehouseId'];
      this.isEditMode = !!this.warehouseId;

      if (this.isEditMode) {
        this.warehouseService.getWarehouseById(this.warehouseId).subscribe({
          next: (warehouse: any) => {
            document.title = 'Update Unit';

            this.companyId = warehouse.companyID
              ;

            this.createWarehouseForm.patchValue(warehouse);
          },
          error: err => console.error(err)
        });
      } else {
        this.resetForm();
      }
    });
  }
  resetForm() {
    this.createWarehouseForm.reset();
    this.createWarehouseForm.controls.isActive.setValue(true);
  }

  get formControls() {
    return this.createWarehouseForm.controls;
  }

  validateForm() {
    let isValid = true;
    if (this.createWarehouseForm.invalid) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please fill Required field' })
      isValid = false;
    }

    return isValid;
  }

  saveWarehouse(data: any, isEditMode: boolean) {
    this.submitted = true;
    const isValid = this.validateForm();
    if (!isValid) {
      return;
    }
    if (isEditMode) {
      this.updateWarehouse(data);
    } else {
      this.createWarehouse(data);
    }
  }

  updateWarehouse(data: any) {
    this.submitted = true;

    if (this.createWarehouseForm.invalid) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Warning',
        detail: 'Please fill Required field'
      });
      return;
    }

    data.companyId = this.companyId;
    data.warehouseId = this.warehouseId;
    data.updatedBy = localStorage.getItem('username');

    this.warehouseService.updateWarehouse(data).subscribe({
      next: (res: any) => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Unit Updated Successfully.'
        });
        setTimeout(() => {
          this.router.navigate(['/home/listWarehouse']);
        }, 1000);
      },
      error: err => console.log(err)
    });
  }

  createWarehouse(data: any) {
    this.submitted = true;
    const isValid = this.validateForm();
    if (!isValid) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please fill Required field' });
      return;
    }

    const state = this.createWarehouseForm.controls.address.controls.state.value;
    data.CreatedBy = localStorage.getItem('username');
    this.warehouseService.createWarehouse(data).subscribe({
      next: (data: any) => {
        if (!data.success) {
          this.messageService.add({
            severity: 'warn',
            summary: 'Duplicate UnitSerial',
            detail: 'UnitSerial already exists.'
          });
          return;
        }

        if (data.success === true) {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: data.message });
          setTimeout(() => {
            this.router.navigate(['/home/listWarehouse']);
          }, 1000);
        } else {
          this.messageService.add({ severity: 'error', summary: 'Failed', detail: data.message });
        }
      },
      error: error => {
        console.log(error);
      }
    })
  }


  Cancel() {
    this.router.navigate(['/home/listWarehouse']);
  }


  getStateList() {
    this.customerService.getStateList().subscribe({
      next: (data: any) => {
        this.stateList = data;
      },
      error: error => {
        console.log(error);
      }
    });
  }

  filterState(event: any) {
    let filtered: any[] = [];
    let query = event.query;

    for (let i = 0; i < (this.stateList as any[]).length; i++) {
      let state = (this.stateList as any[])[i];
      if (state.stateName.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(state);
      }
    }

    this.filterStates = filtered;
  }

  // setState(event: any) {
  //   this.createWarehouseForm.controls.address.controls.state.setValue(event.value.stateName);
  //   this.createWarehouseForm.controls.gstin.setValue(event.value.stateCode);
  // }

  setState(event: any) {
    this.createWarehouseForm.patchValue({
      gstin: event.value.stateCode,
      address: {
        state: event.value.stateName,
        stateCode: event.value.stateCode,
        CreatedBy: localStorage.getItem('username'),
      }
    });
    if (this.isEditMode) {
      this.createWarehouseForm.patchValue({
        gstin: event.value.stateCode,
        address: {
          state: event.value.stateName,
          stateCode: event.value.stateCode,
          UpdatedBy: localStorage.getItem('username'),
        }
      });
    }
  }

  checkState() {
    const enteredState = this.createWarehouseForm.controls.address.controls.state.value;
    const validStates = this.stateList.map(state => state.stateName);

    if (validStates.includes(enteredState)) {
      // console.log('Valid state:', enteredState);
    } else {
      // console.log('Invalid state:', enteredState);
      this.createWarehouseForm.controls.address.controls.state.setValue('');
    }
  }
  onKeydown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.moveToNextField(event);
    }
  }

  moveToNextField(event: KeyboardEvent) {
    const inputs = Array.from(document.querySelectorAll('input')) as HTMLInputElement[];
    const index = inputs.indexOf(event.target as HTMLInputElement);
    if (index > -1 && index < inputs.length - 1) {
      (inputs[index + 1] as HTMLInputElement).focus();
    }
  }
  focusNextInput(event: Event): void {
    const keyboardEvent = event as KeyboardEvent;
    keyboardEvent.preventDefault(); // Prevent form submission on Enter key press

    const target = keyboardEvent.target as HTMLElement;
    const formElements = Array.from((target.closest('form') as HTMLFormElement).elements) as HTMLElement[];
    const index = formElements.indexOf(target);

    if (index > -1 && index < formElements.length - 1) {
      const nextElement = formElements[index + 1];
      nextElement.focus();
    }
  }

  items: MenuItem[] = [
    {
      label: 'GL Defaults',
      command: () => this.showGlDefaultLookup(),
    },
    {
      label: 'Department Defaults ',
      command: () => this.showDepartmentDefaultLookup(),
    },
  ];


  showGlDefaultLookup() {
    this.ref = this.dialogService.open(GLDefaultsLookupComponent, {
      header: `General Ledger Defaults for ${this.createWarehouseForm.controls.warehouseName.value}`,
      width: '85%',
      height: '85%',
      data: { WarehouseName: this.createWarehouseForm.controls.warehouseName.value, warehouseId: this.warehouseId }
    });
  }

  showDepartmentDefaultLookup() {
    this.ref = this.dialogService.open(DepartmentDefaultLookupComponent, {
      header: `Department Defaults for ${this.createWarehouseForm.controls.warehouseName.value}`,
      width: '85%',
      height: '85%',
      data: { WarehouseName: this.createWarehouseForm.controls.warehouseName.value, warehouseId: this.warehouseId }
    });
  }


  // getGstinValidationSetting(): void {
  //   this.inventoryService
  //     .getUnitByAppKey('enable_gstin_validation')
  //     .subscribe({
  //       next: (res: any) => {
  //         this.isGstinValidationEnabled =
  //           res?.data?.toString().toUpperCase() === 'Y';

  //         this.applyGstinValidation(); // 🔥 IMPORTANT
  //       },
  //       error: (err) => {
  //         console.error('GSTIN setting fetch failed', err);
  //         this.isGstinValidationEnabled = false;

  //         this.applyGstinValidation(); // fallback
  //       }
  //     });
  // }

  // applyGstinValidation() {
  //   const gstinControl = this.createWarehouseForm.get('gstin');

  //   if (this.isGstinValidationEnabled) {
  //     // Field level
  //     gstinControl?.setValidators([
  //       Validators.required,
  //       gstinValidator()
  //     ]);

  //     // Form level
  //     this.createWarehouseForm.setValidators(gstinStateMatchValidator);
  //   } else {
  //     // Remove all GST related validations
  //     gstinControl?.clearValidators();
  //     this.createWarehouseForm.clearValidators();
  //   }

  //   gstinControl?.updateValueAndValidity();
  //   this.createWarehouseForm.updateValueAndValidity();
  // }

  isEinvoiceEnabled = false;

  getEinvoiceSetting(): void {
    this.inventoryService
      .getUnitByAppKey('enable_einvoice')
      .subscribe({
        next: (res: any) => {
          this.isEinvoiceEnabled =
            res?.data?.toString().toUpperCase() === 'Y';

          this.applyGstinValidation();
        },
        error: () => {
          this.isEinvoiceEnabled = false;
          this.applyGstinValidation();
        }
      });
  }
  applyGstinValidation() {
    const gstinControl = this.createWarehouseForm.get('gstin');

    if (this.isEinvoiceEnabled) {
      gstinControl?.setValidators([
        Validators.required,
        gstinValidator()
      ]);

      this.createWarehouseForm.setValidators(gstinStateMatchValidator);
    } else {
      gstinControl?.clearValidators();
      this.createWarehouseForm.clearValidators();
    }

    gstinControl?.updateValueAndValidity();
    this.createWarehouseForm.updateValueAndValidity();
  }



}

